import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';

import './i18n';

import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import QuotationPage from './containers/Quotation/pages/quotation-page';
import Reservation from './containers/Reservation/reservation';
import Layout from './containers/Layout/layout';
import Domain from './containers/Domain/pages/domain';
import HouseDetails from './containers/Domain/pages/house-details';
import Infos from './containers/Infos/infos';
import Contact from './containers/Contact/contact';
import History from './containers/History/history';
import Events from './containers/Events/events';
import Services from './containers/Services/services';
import ErrorPage from "./containers/Error/error-page";
import AnnexDetails from './containers/Domain/pages/annex-details';
import Api from './services/api.service';
import CGV from './containers/CGV/cgv';
import GardenDetails from './containers/Domain/pages/garden-details';
import ServicesQuotation from './containers/Quotation/pages/services';
import CookieConsentBanner from './components/Banner/cookie-consent-banner';
import QuotationGroupPage from './containers/Quotation/pages/quotation-group-page';
import AnnouncementWidget from './components/Widgets/widget-announcement';
import EventInternDetail from './containers/Events/event-public-detail';
import BusinessProposalPage from './containers/BusinessProposal/BusinessProposal';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout children={<App />} showOpaline={false} />,
    errorElement: <ErrorPage />,
  },
  {
    path: '*',
    element: <Layout children={<ErrorPage />} showOpaline={true} />,
  },
  {
    path: '/quotation/services',
    element: <ServicesQuotation />,
  },
  {
    path: '/quotation/services/:id',
    element: <ServicesQuotation />,
  },
  {
    path: '/quotation/:id',
    element: <QuotationPage />,
  },
  {
    path: '/quotation-group/:id',
    element: <QuotationGroupPage />,
  },
  {
    path: '/business-proposal/:id',
    element: <BusinessProposalPage />,
  },
  {
    path: '/reservation',
    element: <Layout children={<Reservation />} showOpaline={true} />,
  },
  {
    path: '/domain',
    element: <Layout children={<Domain />} showOpaline={false} />,
  },
  {
    path: '/gaia',
    element: <Layout children={<HouseDetails />} showOpaline={true} />,
  },
  {
    path: '/hestia',
    element: <Layout children={<AnnexDetails />} showOpaline={true} />,
  },
  {
    path: '/outside',
    element: <Layout children={<GardenDetails />} showOpaline={true} />,
  },
  {
    path: '/services',
    element: <Layout children={<Services />} showOpaline={true} />,
  },
  {
    path: '/events',
    element: <Layout children={<Events />} showOpaline={true} />,
  },
  {
    path: '/events/:slug',
    element: <Layout children={<EventInternDetail />} showOpaline={true} />,
  },
  {
    path: '/history',
    element: <Layout children={<History />} showOpaline={true} />,
  },
  {
    path: '/infos',
    element: <Layout children={<Infos />} showOpaline={true} />,
  },
  {
    path: '/contact',
    element: <Layout children={<Contact />} showOpaline={false} />,
  },
  {
    path: '/cgv',
    element: <Layout children={<CGV />} showOpaline={false} />,
  }
]);

const normalizeAccommodation = (value) => {
  const accommodation = String(value || "domain")
    .trim()
    .toLowerCase();

  if (accommodation === "house") {
    return "home";
  }

  if (
    accommodation === "home" ||
    accommodation === "annex" ||
    accommodation === "domain"
  ) {
    return accommodation;
  }

  return "domain";
};

const getBlockedDates = async () => {
  try {
    const response = await Api.getBlockedDates();
    const { data } = response;

    if (!data?.status) {
      console.log("Error:", data?.error);
      Api.storeBlockedDates([]);
      return;
    }

    const rawBlockedDates = Array.isArray(data.data)
      ? data.data
      : [];

    const blockedDates = rawBlockedDates.map(date => ({
      _id: date._id,

      startDate: new Date(date.start)
        .setHours(0, 0, 0, 0),

      endDate: new Date(date.end)
        .setHours(0, 0, 0, 0),

      typeOfAccommodation:
        normalizeAccommodation(
          date.typeOfAccommodation
        ),

      typeOfBlocking:
        date.typeOfBlocking || null,

      reason:
        date.reason || "",

      madeOnOurAdmin:
        date.madeOnOurAdmin === true
    }));

    Api.storeBlockedDates(blockedDates);
  } catch (error) {
    console.error(
      "An error occurred while loading blocked dates:",
      error
    );

    Api.storeBlockedDates([]);
  }
};

const startApplication = async () => {
  await getBlockedDates();

  ReactDOM
    .createRoot(
      document.getElementById("root")
    )
    .render(
      <React.StrictMode>
        <RouterProvider router={router} />
        <ToastContainer />
        <CookieConsentBanner />
        <AnnouncementWidget />
      </React.StrictMode>
    );

  reportWebVitals();
};

startApplication();